export default class {
    static COMPANY_DATA_UPDATE = 'COMPANY_DATA_UPDATE'
    static INVOICE_MAINTAIN = 'INVOICE_MAINTAIN'
    static INVOICE_DELETED = 'INVOICE_DELETED'
    static SELECTED_INVOICE_HEADER = 'SELECTED_INVOICE_HEADER'
    static ORDER_STATUS_REFRESH = 'ORDER_STATUS_REFRESH'
    static REWARD_POINTS_UPDATE = 'REWARD_POINTS_UPDATE'
}

